import styled, { css } from "styled-components";

const bubbleStyle = css`
  position: relative;
  line-height: 1.6em;
  box-shadow: 0 3px 2px #555;

  &:before {
    content: "";
    position: absolute;
    z-index: 1;
  }
`;

export const UserBubble = styled.div`
  ${bubbleStyle};
  border-radius: 10vw;
  background: white;
  display: inline-flex;
  align-items: center;
  @media screen and (max-width: 600px) {
    margin-left: 7vw;
    padding: 3vw;
    justify-content: center;
    &:before {
      top: calc(50% - 1vw);
      right: calc(100% - 0.5vw);
      border-top: 1vw solid transparent;
      border-bottom: 1vw solid transparent;
      border-left: 7vw solid transparent;
      border-right: 7vw solid white;
    }
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    margin-left: 42px;
    padding: 18px;
    justify-content: center;
    &:before {
      top: calc(50% - 3px);
      right: calc(100% - 3px);
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 42px solid transparent;
      border-right: 42px solid white;
    }
  }
  @media screen and (min-width: 961px) {
    margin-left: 2vw;
    padding: 1vw 2vw;
    justify-content: flex-start;
    min-height: 60px;
    &:before {
      top: calc(50% - 0.25vw);
      right: calc(100% - 0.5vw);
      border-top: 0.25vw solid transparent;
      border-bottom: 0.25vw solid transparent;
      border-left: 2vw solid transparent;
      border-right: 2vw solid white;
    }
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    min-height: 80px;
  }
  @media screen and (min-width: 1921px) {
    min-height: 100px;
  }
`;

export const AnswererBubble = styled.div`
  ${bubbleStyle};
  border-radius: 1vw;
  background: #1a1a1a;
  color: white;
  display: inline-flex;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    margin-right: 2vw;
    padding: 3vw;
    &:before {
      top: calc(50% - 1vw);
      left: 100%;
      border-top: 1vw solid transparent;
      border-bottom: 1vw solid transparent;
      border-left: 6.5vw solid #1a1a1a;
      border-right: 6.5vw solid transparent;
    }
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    margin-right: 42px;
    padding: 18px;
    &:before {
      top: calc(50% - 3px);
      left: 100%;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 42px solid #1a1a1a;
      border-right: 42px solid transparent;
    }
  }
  @media screen and (min-width: 961px) {
    margin-right: 2.4vw;
    justify-content: center;
    padding: 1vw 2vw;
    min-height: 60px;
    &:before {
      top: calc(50% - 0.25vw);
      left: 100%;
      border-top: 0.25vw solid transparent;
      border-bottom: 0.25vw solid transparent;
      border-left: 2vw solid #1a1a1a;
      border-right: 2vw solid transparent;
    }
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    min-height: 80px;
  }
  @media screen and (min-width: 1921px) {
    min-height: 100px;
  }
`;
